import React from 'react';
//import { QrReader } from 'react-qr-reader';
import { Scanner } from '@yudiel/react-qr-scanner';
// navigate, useNavigate
import { Button } from 'primereact/button';

export const QrScaner = (props) => {
    //const [data, setData] = useState('No result');

    const { onScane, onClose } = props;

    return (
        <>
            {/* <QrReader
                            constraints={{
                                facingMode: 'environment'
                            }}
                            onResult={(result, error) => {
                                if (!!result) {
                                    //setData(result?.text);
                                    onScane(result?.text);
                                }

                                if (!!error) {
                                    console.info(error);
                                }
                            }}
                            style={{ width: '100%' }}
                        /> */}
            <Scanner
                formats={['code_128', 'code_39', 'code_93', 'codabar', 'ean_13', 'ean_8', 'itf', 'qr_code']}
                onError={(err) => console.error(err)}
                onScan={(result) => {
                    if (result[0]) {
                        onScane(result[0].rawValue);
                    }
                }}
            />
            <p className="text-center text-400 mb-2">
                Usmerite kameru ka Barkod kodu
                <br />
                <Button
                    label=" Ne može da skenira? Unesi ručno"
                    onClick={() => {
                        onClose();
                    }}
                    className="btn btn-sm btn-outline-secondary mt-2"
                ></Button>
            </p>
        </>
    );
};
